import { Injectable } from '@angular/core';
import {
  BehaviorSubject,
  Observable,
  timer,
  Subject,
  ReplaySubject,
} from 'rxjs';
import { map } from 'rxjs/operators';

import { SidebarSize } from './sidebar.enum';
import { IQuoteInput } from '@nibtravel/shared/data-access/quote';

@Injectable()
export class SidebarService {
  private showHost$ = new BehaviorSubject<boolean>(false);
  private showSidebar$ = new BehaviorSubject<boolean>(false);
  private size$ = new BehaviorSubject<SidebarSize>(SidebarSize.OneThird);
  currentClickedButton$ = new Subject();
  animationTimer = 400;
  private quoteInputReplay$ = new ReplaySubject<IQuoteInput>(1);
  /**
   * Observable responsible for controlling the display of the sidebar host comppnent.
   * It's necessary to have two separate observables to allow the animation to execute.
   */
  showSidebarHost(): Observable<boolean> {
    return this.showHost$.asObservable();
  }

  /**
   * Observable responsible for controlling the display of the sidebar comppnent.
   * It's necessary to have two separate observables to allow the animation to execute.
   */
  showSidebar(): Observable<boolean> {
    return this.showSidebar$.asObservable();
  }

  /** Observable responsible for setting the class that defines the sidebar horizontal size */
  sidebarSize(): Observable<string> {
    return this.size$.pipe(map((size) => `main-sidebar--${size}`));
  }

  /**
   * Set the observables that controls the display to true
   *
   * NOTE: The open function adds a delay to the sidebar component
   * so the fade in animation on sidebar can execute.
   */
  open(): void {
    this.showHost$.next(true);
    timer(this.animationTimer / 2).subscribe(() =>
      this.showSidebar$.next(true)
    );
  }

  updateLastInput(value: any) {
    this.quoteInputReplay$.next(value);
  }

  getLastInput() {
    return this.quoteInputReplay$.asObservable();
  }
  /**
   * Set the observables that controls the display to false.
   *
   * NOTE: The close function adds a delay to the host component
   * so the fade out animation on sidebar can execute.
   */
  close(): void {
    this.showSidebar$.next(false);
    timer(this.animationTimer).subscribe(() => this.showHost$.next(false));
  }

  /** The public function to set the sidebar size. */
  setSidebarSize(value: SidebarSize): void {
    this.size$.next(value);
  }
}
